(function () {
    'use strict';

    angular
        .module('ib-tooltip-module')
        .controller('TooltipController', TooltipController);

    TooltipController.$inject = ['$rootScope'];
    function TooltipController ( $rootScope) {
        const vm = this;
        vm.openAdvancedSearch = openAdvancedSearch;
        vm.backToMultiFlightSearch = backToMultiFlightSearch;

        activate();

        function activate () {
        }

        function openAdvancedSearch () {
            vm.advancedSearch = true;
            $rootScope.$broadcast('toggleAdvancedSearch', true );
        }

        function backToMultiFlightSearch (goToHome) {
            $rootScope.$emit('backToMultiFlightSearchEvent', goToHome);
        }
    }
})();
